import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { finalize } from 'rxjs';
import { NotificationListModel } from '../../../../core/models/notification/notification-content-list.model';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-email-notifications',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './email-notifications.component.html',
  styleUrl: './email-notifications.component.scss',
})
export class EmailNotificationsComponent {
  emailNotifications: NotificationListModel[] = [];
  totalEmailNotifications: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes: number[] = [10, 25, 50, 100];
  currentPage: number = 1;
  emailNotificationListLoading: boolean = true;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getEmailNotificationList(this.currentPage, this.pageSize);
  }

  getEmailNotificationList(page: number, size: number): void {
    this.notificationService
      .notificationTemplate(page, size, 1)
      .pipe(
        finalize(() => {
          this.emailNotificationListLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.emailNotifications = res.items;
          this.totalEmailNotifications = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
        error: () => {},
      });
  }

  navigateToEdit(notification: any) {
    this.router.navigate(
      ['/notification-contents/email/edit', notification.id],
      {
        state: { notification },
      }
    );
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.getEmailNotificationList(this.currentPage, this.pageSize);
    }
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSize = size;
    this.currentPage = 1;
    this.getEmailNotificationList(this.currentPage, this.pageSize);
  }

  getLanguageText(code: string): string {
    if (code === 'en') return 'English';
    else if (code === 'nl') return 'Dutch';
    else return 'Unknown';
  }
}
